const HeaderSimulatorView = Backbone.View.extend({

  id: 'lqd-header-sim-states',

  template: _.template(`<div class="lqd-header-sim-title"><h3>Simulator</h3></div><button id="lqd-header-sim-sticky" class="lqd-header-sim-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-credit-card"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><rect x="1" y="4" width="22" height="7" rx="2" ry="2" fill="currentColor" stroke="none"></rect></svg><span>Sticky</span></button>
  <button id="lqd-header-sim-light-bg" class="lqd-header-sim-btn" data-scheme="light"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sun"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg><span>Light</span></button>
  <button id="lqd-header-sim-dark-bg" class="lqd-header-sim-btn" data-scheme="dark"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg><span>Dark</span></button>
  <button id="lqd-header-sim-reset-bg" class="lqd-header-sim-btn" data-scheme="reset"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-rotate-ccw"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg><span>Reset</span></button>`),

  events: {
    'click #lqd-header-sim-sticky': 'simSticky',
    'click #lqd-header-sim-light-bg, #lqd-header-sim-dark-bg, #lqd-header-sim-reset-bg': 'setScheme',
  },

  $body: null,
  $mainHeader: null,

  initialize: function() {

    this.render();

    this.$el.appendTo('body');

    this.listenTo(this.model, 'change:isStuck', this.onStuckChange);
    this.listenTo(this.model, 'change:isOverLight', this.onSchemeChange);
    this.listenTo(this.model, 'change:isOverDark', this.onSchemeChange);
    
  },

  render: function() {

    this.$el.html(this.template());

    return this;

  },

  simSticky: function(ev) {

    this.model.set('isStuck', ! this.model.get('isStuck'));

    ev.currentTarget.classList.toggle('active', this.model.get('isStuck'));

  },

  setBgColor: function(event) {
    const bgColor = event.currentTarget.dataset.bgColor;
    this.model.set('currentBgColor', bgColor);
  },

  setScheme: function(event) {

    const button = event.currentTarget;
    const scheme = button.dataset.scheme;

    switch (scheme) {
      case 'light':
        this.model.set({
          isOverLight: true,
          isOverDark: false
        });
        break;
      case 'dark':
        this.model.set({
          isOverLight: false,
          isOverDark: true
        });
        break;
      default:
        this.model.set({
          isOverLight: false,
          isOverDark: false
        });
    }

  },

  onStuckChange: function(model, newStickyState) {

    const {stickyHeader} = this.model.get('classnames');
    const $mainHeader = this.getMainHeader();

    $mainHeader.toggleClass(stickyHeader, newStickyState);
    
  },

  onSchemeChange: function() {

    const {overLightRow, overDarktRow} = this.model.get('classnames');
    const {dynamicColorElements} = this.model.get('selectors');
    const {light: lightBgColor, dark: darkBgColor} = this.model.get('backgrounds');
    const {changed} = this.model;
    const $dynamicColorElements = elementorFrontend.elements.$document.find(dynamicColorElements);
    const $body = this.getBody();

    this.$el.find('[data-scheme]').removeClass('active');

    $dynamicColorElements.add(this.$el).removeClass([overLightRow, overDarktRow]);
    $body.css('background-color', '');
    
    if ( changed.isOverLight ) {
      $dynamicColorElements.add(this.$el).addClass(overLightRow);
      $body.css('background-color', lightBgColor);
      this.$el.find('[data-scheme=light]').addClass('active');
    }
    if ( changed.isOverDark ) {
      $dynamicColorElements.add(this.$el).addClass(overDarktRow);
      $body.css('background-color', darkBgColor);
      this.$el.find('[data-scheme=dark]').addClass('active');
    }
    
  },

  getMainHeader() {

    if ( this.$mainHeader ) {
      return this.$mainHeader;
    }

    const {mainHeader} = this.model.get('selectors');

    return elementorFrontend.elements.$document.find(mainHeader);
    
  },

  getBody() {

    if ( this.$body ) {
      return this.$body;
    }

    return elementorFrontend.elements.$body;

  }

});

export default HeaderSimulatorView;